import RichTextLimited from '../Common/RichTextLimited';

const RichTextLimitedWrapper = objProps => {
  return <RichTextLimited {...objProps.field} {...objProps} />;
};

export default RichTextLimitedWrapper;
